import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { bool, shape, string } from 'prop-types';
import Flex from '@magalu/stereo-ui/atoms/Flex';
import { Chat } from '@magalu/stereo-ui-icons';
import { routePush } from '@magalu/mixer-utils';
import withLayoutProps from '../../../hocs/withLayoutProps';
import SellerFollowButton from './SellerFollowButton';
import { ButtonStyled } from './SellerChatAndFollowButtons.styles';
var SellerChatAndFollowButtons = function SellerChatAndFollowButtons(_ref) {
  var customerId = _ref.customerId,
    customStyles = _ref.customStyles,
    isChatEnabled = _ref.isChatEnabled,
    productId = _ref.productId,
    sellerId = _ref.sellerId,
    userIsLogged = _ref.userIsLogged;
  var isFirstParty = sellerId === 'magazineluiza';
  var openChat = function openChat() {
    routePush({
      path: "/chat-com-lojista/p/".concat(sellerId, "/").concat(productId),
      spa: true
    });
  };
  var styleButtonProps = customStyles !== null && customStyles !== void 0 ? customStyles : {};
  return !isFirstParty && isChatEnabled ? React.createElement(Flex, {
    lineHeight: 1,
    gap: 2
  }, React.createElement(Flex, {
    justifyContent: "flex-start"
  }, React.createElement(ButtonStyled, _extends({
    size: "small",
    color: "primary",
    variation: "outline",
    startIcon: React.createElement(Chat, {
      width: 20,
      height: 20
    }),
    onClick: openChat,
    "data-testid": "chat-with-seller",
    centered: true
  }, styleButtonProps), "Fale com lojista")), userIsLogged ? React.createElement(Flex, {
    justifyContent: "flex-end"
  }, React.createElement(SellerFollowButton, {
    customerId: customerId,
    sellerId: sellerId,
    styleButtonProps: styleButtonProps
  })) : null) : null;
};
process.env.NODE_ENV !== "production" ? SellerChatAndFollowButtons.propTypes = {
  customerId: string,
  customStyles: shape({}),
  isChatEnabled: bool,
  productId: string,
  sellerId: string,
  userIsLogged: bool
} : void 0;
SellerChatAndFollowButtons.defaultProps = {
  customerId: '',
  customStyles: null,
  isChatEnabled: false,
  productId: '',
  sellerId: '',
  userIsLogged: false
};
SellerChatAndFollowButtons.ssr = true;
export default withLayoutProps(SellerChatAndFollowButtons);